import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ReactLenis, useLenis } from "lenis/react";
import "./App.css";
import SiteHeader from "./components/SiteHeader";
import Footer from "./components/Footer";
import AdminPage from "./pages/AdminPage";
import ClientPortalPage, { ClientAuthCallback } from "./pages/ClientPortalPage";
import ListenPage from "./pages/ListenPage";
import { getPaymentStatus } from "./lib/api";
import { AboutPage, BookPage, ContactPage, HomePage, IfaPage, LeadershipPage, MusicPage, SangoPage, ShopPage, TheaterPage, WellnessPage } from "./pages/PublicPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <ClientAuthCallback />;
  return <Routes><Route path="/" element={<HomePage />} /><Route path="/about" element={<AboutPage />} /><Route path="/ifa-consultations" element={<IfaPage />} /><Route path="/wellness-fitness" element={<WellnessPage />} /><Route path="/sango-experience" element={<SangoPage />} /><Route path="/music-culture" element={<MusicPage />} /><Route path="/listen" element={<ListenPage />} /><Route path="/royal-leadership-mowa" element={<LeadershipPage />} /><Route path="/culture-community" element={<LeadershipPage />} /><Route path="/cultural-arts-theater" element={<TheaterPage />} /><Route path="/book-oba" element={<BookPage />} /><Route path="/shop" element={<ShopPage />} /><Route path="/contact" element={<ContactPage />} /><Route path="/portal" element={<ClientPortalPage />} /><Route path="/admin" element={<AdminPage />} /><Route path="/payment/success" element={<PaymentStatusPage />} /><Route path="/payment/cancel" element={<PaymentStatusPage cancelled />} /><Route path="*" element={<HomePage />} /></Routes>;
}


function PaymentStatusPage({ cancelled = false }) {
  const location = useLocation();
  const [state, setState] = useState(cancelled ? "cancelled" : "verifying");

  useEffect(() => {
    if (cancelled) return undefined;
    const sessionId = new URLSearchParams(location.search).get("session_id");
    if (!sessionId) { setState("pending"); return undefined; }
    let active = true;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const data = await getPaymentStatus(sessionId);
        if (!active) return;
        if (data?.payment_status === "paid") { setState("confirmed"); return; }
      } catch (error) { /* transient — keep retrying */ }
      if (active && attempts < 12) setTimeout(poll, 2000);
      else if (active) setState("pending");
    };
    poll();
    return () => { active = false; };
  }, [cancelled, location.search]);

  const content = {
    cancelled: { title: "Checkout paused.", copy: "No appointment has been confirmed. Return to Book Oba when you are ready." },
    verifying: { title: "Confirming your payment…", copy: "Please keep this page open for a moment while we verify your payment with Stripe." },
    confirmed: { title: "Payment confirmed.", copy: "Your booking is confirmed and a confirmation email is on its way. We look forward to welcoming you." },
    pending: { title: "Payment received.", copy: "Your payment is being verified. Your service confirmation will arrive by email once the payment status is confirmed." },
  }[state];

  return <main className="page-wrap section" data-testid={cancelled ? "payment-cancelled-page" : "payment-success-page"}><span className="eyebrow">Secure checkout</span><h1 className="section-title" data-testid="payment-status-title">{content.title}</h1><p className="section-lede" data-testid="payment-status-copy">{content.copy}</p><a className="button-gold" href="/book-oba" data-testid="payment-return-button">Return to booking</a></main>;
}

export default function App() {
  return <BrowserRouter><ReactLenis root options={{ autoRaf: true, respectReducedMotion: true }}><ScrollToTop /><div className="app-shell"><SiteHeader /><div className="site-main"><AppRouter /></div><Footer /></div></ReactLenis></BrowserRouter>;
}
